import { BLOCK_TYPES } from '../blocks/types.js';
import { SERVICE_CATALOG, servicePath } from '../../navigation/serviceCatalog.js';

// Service Content — Chauffeur by the Hour / mise à disposition (golden pattern: PR #250/#251/#252).
// Authored FRENCH content from existing Content-Platform blocks + VERIFIED facts already live on site:
//   - mise à disposition de véhicule avec chauffeur  (locales: services "Mise à disposition", legal list4)
//   - use cases: événements / journées business / occasions spéciales  (locales: services "Mise à disposition" desc)
//   - chauffeur privé premium, ponctualité, discrétion, confort, online booking, price-before-booking, SAB area
// OPERATIONAL-RISK GUARD: NO guaranteed availability, NO dedicated-chauffeur guarantee (the site's
// "chauffeur dédié" wording is deliberately NOT reused), NO minimum duration, NO half-day/day package,
// NO hourly rate, NO exact price, NO "waiting time included", NO event-coordination, NO concierge.
// Duration is framed as flexibility ("pour la durée de votre choix"), never as a defined package.
// "à l'heure" is the service descriptor (catalogue "Chauffeur by the Hour"), not a rate. Vehicles
// BRAND-NEUTRAL. No fabricated claims. CTA offers book OR request (/reserver + /contact). Mesh derived
// from the ratified catalogue.

const SLUG = 'chauffeur-by-the-hour';
const siblings = SERVICE_CATALOG
  .filter((s) => s.slug !== SLUG)
  .map((s) => ({ label: s.name, to: servicePath(s.slug) }));

export default {
  blocks: [
    {
      type: BLOCK_TYPES.HERO,
      kicker: 'Chauffeur privé premium',
      title: 'Mise à disposition de chauffeur privé à Nantes',
      lead:
        'Un chauffeur privé à votre disposition à Nantes et en Loire-Atlantique, à l’heure et pour la durée qui vous convient — flexible, ponctuel et discret.',
    },
    {
      type: BLOCK_TYPES.INTRO,
      text:
        'Black Matte met un chauffeur privé à votre disposition pour vos rendez-vous, vos événements et vos déplacements professionnels, à Nantes et en Loire-Atlantique. Véhicules haut de gamme, réservation en ligne et prix communiqué avant de réserver.',
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Pourquoi choisir un chauffeur à disposition',
      body: [
        'La mise à disposition vous permet de réserver un chauffeur privé pour la durée de votre choix, plutôt qu’un trajet unique — pratique pour une succession de rendez-vous, un événement ou une journée chargée. Vous vous déplacez à votre rythme, sans gérer le stationnement ni l’itinéraire.',
        'Vous voyagez à bord d’un véhicule haut de gamme, confortable et soigné, conduit par un chauffeur privé professionnel et discret. Le prix vous est communiqué avant la réservation, en toute transparence.',
      ],
    },
    {
      type: BLOCK_TYPES.FEATURE_GRID,
      heading: 'Un service souple et premium',
      items: [
        { title: 'Flexibilité', text: 'Un chauffeur à disposition pour la durée de votre choix, au gré de vos rendez-vous et de vos étapes.' },
        { title: 'Ponctualité', text: 'Une prise en charge à l’heure, pour chacun de vos déplacements.' },
        { title: 'Discrétion', text: 'Un service professionnel et confidentiel, propice au travail comme aux échanges.' },
        { title: 'Confort', text: 'Un véhicule haut de gamme, calme et soigné, à chacun de vos trajets.' },
      ],
    },
    {
      type: BLOCK_TYPES.STEPS,
      heading: 'Comment réserver votre chauffeur à disposition',
      steps: [
        { title: 'Indiquez votre besoin', text: 'Précisez votre point de départ, la date, l’heure et la nature de votre déplacement.' },
        { title: 'Obtenez votre prix', text: 'Votre tarif vous est communiqué avant toute confirmation.' },
        { title: 'Réservez ou contactez-nous', text: 'Validez en ligne, ou contactez-nous pour une mise à disposition sur mesure.' },
        { title: 'Votre chauffeur vous accompagne', text: 'Votre chauffeur vous prend en charge à l’heure convenue, à Nantes et en Loire-Atlantique.' },
      ],
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Des usages variés à Nantes et en Loire-Atlantique',
      body: [
        'La mise à disposition s’adapte à de nombreuses occasions : rendez-vous d’affaires et journées professionnelles, événements et occasions spéciales, ou simplement une succession de trajets dans la même journée.',
        'Black Matte intervient à Nantes et dans sa région, ainsi qu’à Angers, Rennes et La Roche-sur-Yon, 24h/24 et 7j/7, avec des chauffeurs privés professionnels et discrets.',
      ],
    },
    {
      type: BLOCK_TYPES.CTA,
      heading: 'Réservez votre chauffeur à disposition',
      text: 'Réservez votre chauffeur privé à l’heure, ou contactez-nous pour une mise à disposition sur mesure.',
      actions: [
        { label: 'Réserver', to: '/reserver' },
        { label: 'Nous contacter', to: '/contact' },
      ],
    },
    {
      type: BLOCK_TYPES.RELATED_CONTENT,
      heading: 'Autres prestations',
      links: siblings,
    },
  ],
};
